<template>
	<div class="app-modal-custom-wrapper" :style="{ zIndex }" ref="modalWrapper">
		<div class="app-modal-custom-backdrop"></div>

		<div :class="['app-modal-custom', `app-modal-custom--${variant}`, 'app-modal-custom--scrollable']">
			<div class="app-modal-custom-header">
				<template v-if="showBackButton">
					<DismissButton class="me-3" :onClick="() => $emit('back')" />
				</template>

				<slot name="header">
					{{ title }}
				</slot>
			</div>

			<div class="app-modal-custom-body" :style="{ zIndex: zIndex + 1 }">
				<slot />
			</div>

			<div class="app-modal-custom-footer" v-if="$slots.footer">
				<slot name="footer" />
			</div>
		</div>
	</div>
</template>

<script>
import { getHighestZIndex } from '@/utils'
import * as bootstrap from 'bootstrap'
import DismissButton from '@/components/shared/DismissButton.vue'

export default {
	name: 'CustomModal',
	components: { DismissButton },
	props: {
		title: String,
		variant: {
			type: String,
			default: 'centered' // 'centered' o 'fullscreen'
		},
		autoFocus: {
			type: Boolean,
			default: true // ✅ Nuevo: control de autofocus
		},
		showBackButton: {
			type: Boolean,
			default: false
		}
	},
	data() {
		const highest = getHighestZIndex('.app-modal-custom-wrapper')
		return {
			zIndex: highest + 10
		}
	},
	mounted() {
		if (window.visualViewport) {
			this.updateModalHeight()
			window.visualViewport.addEventListener('resize', this.updateModalHeight)
		}
		this.activateFocusTrap()
		this.releaseBootstrapFocus()
	},
	beforeUnmount() {
		if (window.visualViewport) {
			window.visualViewport.removeEventListener('resize', this.updateModalHeight)
		}
		this.deactivateFocusTrap()
	},
	methods: {
		close() {
			this.$emit('close')
		},
		updateModalHeight() {
			const height = window.visualViewport.height
			document.documentElement.style.setProperty('--app-modal-height', `${height}px`)
		},
		activateFocusTrap() {
			const focusable = this.$refs.modalWrapper.querySelectorAll('a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])')
			const first = focusable[0]
			const last = focusable[focusable.length - 1]

			this._focusHandler = (e) => {
				if (e.key === 'Tab') {
					if (e.shiftKey && document.activeElement === first) {
						e.preventDefault()
						last?.focus()
					} else if (!e.shiftKey && document.activeElement === last) {
						e.preventDefault()
						first?.focus()
					}
				}
			}

			document.addEventListener('keydown', this._focusHandler)

			this.$nextTick(() => {
				if (this.autoFocus && first) {
					first.focus()
				}
			})
		},
		deactivateFocusTrap() {
			document.removeEventListener('keydown', this._focusHandler)
		},
		releaseBootstrapFocus() {
			const modals = document.querySelectorAll('.modal.show')
			modals.forEach((modalEl) => {
				const instance = bootstrap.Modal.getInstance(modalEl)
				if (instance && instance._focustrap?.deactivate) {
					instance._focustrap.deactivate()
				}
				if (document.activeElement && modalEl.contains(document.activeElement)) {
					document.activeElement.blur()
				}
			})
		}
	}
}
</script>
